exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".avatar-uploader[data-v-ad847764]  .el-upload{border:0.01333rem dashed #d9d9d9;border-radius:0.08rem;cursor:pointer;position:relative;overflow:hidden}.avatar-uploader[data-v-ad847764]  .el-upload:hover{border-color:#409eff}.avatar-uploader .avatar-uploader-icon[data-v-ad847764]{font-size:0.37333rem;color:#8c939d;width:1.33333rem;height:1.33333rem;line-height:1.33333rem;text-align:center}.avatar-uploader .el-avatar_up[data-v-ad847764]{width:100%;height:100%}.avatar-uploader .el-avatar[data-v-ad847764]{background:none}.el-upload__tip[data-v-ad847764]{margin:0 0 0.13333rem;line-height:initial}", ""]);

// exports
